module.exports = __webpack_public_path__ + "static/leadrx-new-ui-6becd3cd1990c1522ff0cfb395a9f286.png";